






































































import Vue from 'vue';
import { RoleService } from '@/services/RoleService';
import { RoleModel, RouteRegEx } from '@/types';
import MStoreTable from '@/components/shared/Table/MStoreTable.vue';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import { ComponentHelper, MTablehelper, RouteHelpers } from '@/mixins';

export default Vue.extend({
  name: 'RoleManagement',
  mixins: [ComponentHelper, MTablehelper, RouteHelpers],
  data() {
    return {
      isLoading: false,
      pageIsLoading: true,
      roles: [],
      fields: [
        {
          key: 'name',
          sortable: true
        },
        {
          key: 'description',
          sortable: true
        },
        {
          key: 'actions',
          label: '',
          sortable: false
        }
      ]
    };
  },
  methods: {
    async initialise(this: any) {
      this.pageIsLoading = true;
      await this.getRolesAsync();
      this.resetFilters();
      this.pageIsLoading = false;
    },
    async getRolesAsync(this: any) {
      try {
        this.isLoading = true;
        this.roles = await RoleService.getRolesAsync();
      } catch (error) {
        this.handleError(error);
      } finally {
        this.isLoading = false;
      }
    },
    resetFilters(this: any) {
      const canKeepState = this.canKeepState(RouteRegEx.Role);
      if (!canKeepState) {
        this.resetMTableState();
      }
    },
    navigateToId(this: any, routeName: any, data: any = null, paramName: string = 'id') {
      if (data) {
        const value = paramName === 'id' ? data : data.id;
        this.onTableStateFieldUpdated('selectedPk', value);
      }
      this.navigateToRoute(routeName, data, paramName);
    }
  },
  mounted() {
    this.initialise();
  },
  components: {
    MStoreTable,
    LoadingSpinner
  }
});
